import { useState, useCallback } from 'react';

interface Option {
    id: string;
    label: string;
}

interface UseInputDropdownMultiProps {
    placeholder?: string;
    onOptionChange: (selectedOptions: Option[]) => void;
    value?: Option[];
}

export const useInputDropdownMulti = ({ placeholder, onOptionChange, value = [] }: UseInputDropdownMultiProps) => {
    const [inputValue, setInputValue] = useState<string>('');

    const handleInputChange = (value: string) => {
        setInputValue(value);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' && inputValue.trim()) {
            const newOption: Option = {
                id: inputValue.trim(),
                label: inputValue.trim()
            };

            const exists = value.some((option) => option.label.toLowerCase() === inputValue.trim().toLowerCase());

            if (!exists) {
                const updatedOptions = [...value, newOption];
                onOptionChange(updatedOptions);
            }

            setInputValue('');
            event.preventDefault();
        }
    };

    const handleRemoveItem = useCallback(
        (itemToRemove: Option) => {
            const newValue = value.filter((item) => item.id !== itemToRemove.id);
            onOptionChange(newValue);
        },
        [value, onOptionChange]
    );

    const dynamicPlaceholder = value.length > 0 ? `${placeholder} (${value.length})` : placeholder || '';

    return {
        inputValue,
        handleInputChange,
        handleKeyDown,
        handleRemoveItem,
        dynamicPlaceholder
    };
};
